import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchScheduleRegister } from './api';

/** Branch-scoped — a Schedule H1/X sale happens at a specific branch. */
export function useScheduleRegister() {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.pharmacy.scheduleRegister(), branchVersion],
    queryFn: fetchScheduleRegister,
  });
}
